import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { CaseDescriptionView } from '@/components/case-overview/CaseDescriptionView'
import { useUpdateCaseDescription } from '@/hooks/use-case-queries'

interface CaseDescriptionProps {
  caseId: string
  description: string | null
}

/**
 * Connected case-description editor. Persists edits via the case mutation and
 * notifies on success; the pure {@link CaseDescriptionView} owns the UI.
 */
export function CaseDescription({ caseId, description }: CaseDescriptionProps) {
  const { t } = useTranslation()
  const updateDescription = useUpdateCaseDescription(caseId)

  const handleSave = async (draft: string) => {
    await updateDescription.mutateAsync(draft)
    toast.success(t('overview.descriptionUpdated'))
  }

  return (
    <CaseDescriptionView
      description={description}
      saving={updateDescription.isPending}
      onSave={handleSave}
    />
  )
}
